<template>
  <!-- The slide out component for after a user has clicked on the FilterButton component -->
  <!-- The markup for this component was stripped out from the colors template module -->
  <div>
    <aside
      id="modal-colors-filters"
      class="modal modal--flyout modal--left micromodal-slide"
      aria-hidden="true"
    >
      <div class="modal__overlay" tabindex="-1">
        <div
          class="panel__container modal__container filters__container col-12 lg:col-9"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-colors-filters-title"
        >
          <div class="md:grid-wrapper">
            <header class="modal__header">
              <button
                class="button button--panel button--filters hidden md:flex modal__close js-close-panel button--smd"
                data-micromodal-trigger="modal-colors-filters"
                aria-label="Close modal"
                data-micromodal-close
              >
                <span class="button__content">
                  <svg
                    class="icon icon-minus-circle"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <use xlink:href="#icon-minus-circle" />
                  </svg>
                  Filter By
                </span>
              </button>
              <div class="w-full flex justify-between md:hidden px-4 py-6">
                <div id="modal-colors-filters-title" class="p font-medium">
                  Filter by
                </div>
                <button
                  class="modal__close js-close-panel"
                  data-micromodal-trigger="modal-colors-filters"
                  aria-label="Close modal"
                  data-micromodal-close
                >
                  <svg
                    class="icon icon-close"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <use xlink:href="#icon-close" />
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>
            </header>
            <div id="modal-colors-filters-content" class="panel">
              <div class="panel__content modal__content">
                <div class="panel__row mt-2">
                  <div class="filters-column w-full xl:w-1/5" />
                  <div class="filters-column w-full md:w-1/4">
                    <div class="filters-column__inner">
                      <div class="filters-column__content">
                        <filter-scale
                          :title="leftTitle"
                          :options="leftOptions"
                          :options-map="leftOptionsInterpolation"
                          :selected-scale="selectedScale"
                          @select="onScaleSelect"
                          @close="onScaleClear"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="filters-column w-full md:w-1/5" />
                  <div class="filters-column w-full md:w-1/3">
                    <div class="filters-column__inner">
                      <div class="filters-column__content">
                        <filter-colors
                          :options="rightOptions"
                          :selected-color="selectedColor"
                          @select="onSelectColor"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="panel__row flex justify-center md:justify-end flex-row mb-8 md:mb-0"
                >
                  <button
                    class="button button--panel button--filters link-cta mt-0"
                    aria-label="Clear filters"
                    @click="clearAllFilters"
                  >
                    <span class="button__content">
                      <svg
                        class="icon icon-cta"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <use xlink:href="#icon-cta" />
                      </svg>
                      <span class="a">Clear Filter</span>
                    </span>
                  </button>
                  <a
                    class="button button--layer js-close-panel"
                    aria-label="Apply filters"
                    @click="updateAppState"
                  >
                    <span class="button__content">
                      Apply Filter
                      <svg
                        class="icon icon-cta"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <use xlink:href="#icon-cta" />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__bg" data-micromodal-close />
    </aside>
  </div>
</template>
<script>
import { eventBus } from '../../shared/event-bus';
import FilterScale from './components/FilterScale';
import FilterColors from './components/FilterColors';

export default {
  components: {
    FilterScale,
    FilterColors,
  },
  props: [
    'leftTitle',
    'leftOptions',
    'leftOptionsInterpolation',
    'rightTitle',
    'rightOptions',
    'propSelectedScale',
    'propSelectedColor',
  ],
  data() {
    return {
      selectedScale: {
        ...this.propSelectedScale,
      },
      selectedColor: {
        ...this.propSelectedColor,
      },
    };
  },
  watch: {
    propSelectedScale(newVal, oldVal) {
      if (newVal.option !== oldVal.option) {
        this.selectedScale = { ...newVal };
      }
    },
    propSelectedColor(newVal, oldVal) {
      if (newVal.option !== oldVal.option) {
        this.selectedColor = { ...newVal };
      }
    },
  },
  methods: {
    updateAppState() {
      eventBus.updateSelectedFilters({
        scale: {
          field_id: this.selectedScale.field_id,
          option_id: this.selectedScale.option_id,
          option: this.selectedScale.option,
        },
        color: {
          field_id: this.selectedColor.field_id,
          option_id: this.selectedColor.option_id,
          option: this.selectedColor.option,
        },
      });
      if (MicroModal) {
        MicroModal.close('modal-colors-filters');
      }
    },
    onScaleSelect(data) {
      this.selectedScale = data;
    },
    onScaleClear() {
      this.selectedScale = {
        field_id: '',
        option_id: '',
        option: '',
      };
    },
    onSelectColor(data) {
      this.selectedColor = data;
    },
    clearAllFilters() {
      this.selectedScale = {
        field_id: '',
        option_id: '',
        option: '',
      };
      this.selectedColor = {
        field_id: '',
        option_id: '',
        option: '',
      };
      eventBus.clearAllFilters();
      if (MicroModal) {
        MicroModal.close('modal-colors-filters');
      }
    },
  },
};
</script>
